<svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.43066 27.5V4.5H14.5629L19.864 27.5H3.43066Z" fill="white" stroke="black" stroke-width="1.5"/>
<circle cx="3.43091" cy="4.5" r="1.58618" fill="black"/>
<circle cx="3.43091" cy="27.5" r="1.58618" fill="black"/>
<circle cx="14.6643" cy="4.5" r="1.58618" fill="black"/>
<circle cx="19.8635" cy="27.5" r="1.58618" fill="black"/>
</svg>
